import { ArrowUpRight, Compass, LineChart, Users2, GraduationCap } from "lucide-react";

const services = [
  {
    id: "fk-coaching",
    icon: Compass,
    title: "Führungskräfte-Coaching",
    audience: "Markt- & Vertriebsführung",
    body: "Begleitung der Person in ihrer Individualität — meist im Einzelgespräch. Gemeinsam suchen wir den Weg, häufiger in der persönlichen Mitte zu agieren. Wer sich seines inneren Auftrags und seiner Verantwortung bewusst ist, wächst an den ihm anvertrauten Aufgaben.",
    bullets: [
      "1:1-Sparring zu Rolle, Haltung und Leitmotiven",
      "Klärung des inneren Auftrags & der eigenen Verantwortung",
      "„Arbeite ich ab — oder wachse ich an meiner Aufgabe?“",
    ],
    span: "lg:col-span-7",
  },
  {
    id: "vertriebs-training",
    icon: LineChart,
    title: "Vertriebstrainings",
    audience: "Firmenkunden­berater · Leasing-Vertrieb",
    body: "Meine Arbeit soll sich umgehend in messbaren Ergebnissen zeigen: höhere Cross-Selling-Quoten, deutlich steigende Akquisitions­aktivität und die konsequente Einbindung von Spezialisten im Kundentermin. Begleitung im realen Gespräch — nicht im Rollenspiel.",
    bullets: [
      "Erhöhung der Cross-Selling-Quoten",
      "Spürbar mehr Akquisitions­aktivität der betreuten Person",
      "Systematische Einbindung von Spezialisten beim Kundentermin",
    ],
    span: "lg:col-span-5",
  },
  {
    id: "workshops",
    icon: Users2,
    title: "Workshops",
    audience: "Teams · Führungs­kräfte · Firmenkunden­berater · Leasing-Vertrieb",
    body: "Vertrieb ist eine Kulturfrage. Neben Talent entscheidet die Einstellung zur eigenen Rolle. Verkaufs­techniken lassen sich lernen — Haltung und Rollen­verständnis müssen aus innerer Überzeugung wachsen. Genau das gestalten wir gemeinsam im Team.",
    bullets: [
      "Rollen- und Werte-Klärung im Vertriebs­team",
      "Kulturarbeit: vom Verkaufen zum Verstehen",
      "Markt­bearbeitungs-Sprints mit echtem Transfer",
    ],
    span: "lg:col-span-5",
  },
  {
    id: "programme",
    icon: GraduationCap,
    title: "Entwicklungsprogramme",
    audience: "Nachwuchs · Talente · Spezialisten",
    body: "Zeit- und Erfolgs­druck, schwierige Markt­bedingungen — entscheidend sind immer die eigenen Widerstands­kräfte und das richtige Mindset. Gezielte Aktivitäten stärken genau das: innere Stabilität, klare Positionierung, messbarer Transfer in den Alltag.",
    bullets: [
      "Resilienz & Mindset unter Vertriebs­druck",
      "Perspektiv­wechsel trainieren",
      "Begleitende Einzel-Coachings zur persönlichen Mitte",
    ],
    span: "lg:col-span-7",
  },
];

export default function Services() {
  return (
    <section
      id="leistungen"
      data-testid="services-section"
      className="section-padding bg-[#F9F9FB] border-b border-black/10"
    >
      <div className="max-w-[1440px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-16 mb-12 md:mb-20 items-end">
          <div className="lg:col-span-7">
            <div className="overline mb-4">Leistungen</div>
            <h2 className="font-display font-bold text-3xl sm:text-4xl md:text-5xl tracking-tight leading-[1.05]">
              Vier präzise Hebel.
              <br />
              Ein gemeinsames Ziel:
              <br />
              <span className="text-[#D30000]">wirksamer Vertrieb.</span>
            </h2>
          </div>
          <div className="lg:col-span-5">
            <p className="text-base md:text-lg leading-relaxed text-[#4A4A52]">
              Alle Module sind modular kombinierbar und auf die Realität von
              Sparkassen sowie Leasing­gesellschaften zugeschnitten —
              regulatorisch, kulturell und vertrieblich.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-[1px] bg-black/10 border border-black/10">
          {services.map((s, i) => (
            <article
              key={s.id}
              data-testid={`service-card-${s.id}`}
              className={`bg-white p-8 md:p-12 group transition-colors duration-200 hover:bg-[#0A0A0A] hover:text-white ${s.span}`}
            >
              <div className="flex items-start justify-between mb-8">
                <div className="w-12 h-12 border border-current flex items-center justify-center">
                  <s.icon size={20} strokeWidth={1.5} />
                </div>
                <span className="text-xs font-mono opacity-50">
                  0{i + 1}
                </span>
              </div>

              <h3 className="font-display font-bold text-2xl md:text-3xl tracking-tight leading-tight">
                {s.title}
              </h3>
              <div className="mt-2 text-xs uppercase tracking-[0.18em] opacity-70">
                {s.audience}
              </div>

              <p className="mt-6 text-base leading-relaxed opacity-80 max-w-prose">
                {s.body}
              </p>

              <ul className="mt-6 space-y-2">
                {s.bullets.map((b) => (
                  <li
                    key={b}
                    className="flex items-start gap-3 text-sm leading-relaxed"
                  >
                    <span className="mt-2 w-2 h-[2px] bg-[#D30000] shrink-0" />
                    {b}
                  </li>
                ))}
              </ul>

              <a
                href="#kontakt"
                className="mt-8 inline-flex items-center gap-2 text-sm font-semibold uppercase tracking-[0.18em] hover-marker"
                data-testid={`service-cta-${s.id}`}
              >
                Anfragen <ArrowUpRight size={16} />
              </a>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
